import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import ProjectListPageUI from './ProjectListPageUI.js'

const Sort = {asc: 1, desc: 2, none: 0}

class ProjectListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      projectList: null,
      filteredProjectList: null,
      alphaSort: Sort.none,
      timeSort: Sort.desc,
      projectFilter: true,
      templateFilter: true,
      activeFilter: true,
      archivedFilter: false,
      searchFilter: ''
    }
  }

  render() {
    return (
      <ProjectListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        projectList={this.state.projectList}
        filteredProjectList={this.state.filteredProjectList}
        alphaSort={this.state.alphaSort}
        timeSort={this.state.timeSort}
        projectFilter={this.state.projectFilter}
        templateFilter={this.state.templateFilter}
        activeFilter={this.state.activeFilter}
        archivedFilter={this.state.archivedFilter}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onAlphaSortClick={this.onAlphaSortClick}
        onTimeSortClick={this.onTimeSortClick}
        onProjectFilterClick={this.onProjectFilterClick}
        onTemplateFilterClick={this.onTemplateFilterClick}
        onActiveFilterClick={this.onActiveFilterClick}
        onArchivedFilterClick={this.onArchivedFilterClick}
        onSearchFilterChange={this.onSearchFilterChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProjects(context)
    this.getMessages(context)
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    let projectList = response.projectList.filter(project => project.roleId)

    let filtersStr = sessionStorage.getItem(CacheKeys.ProjectsFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      projectList: projectList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
      projectFilter: filters.hasOwnProperty('projectFilter') ? filters.projectFilter : true,
      templateFilter: filters.hasOwnProperty('templateFilter') ? filters.templateFilter : true,
      activeFilter: filters.hasOwnProperty('activeFilter') ? filters.activeFilter : true,
      archivedFilter: filters.hasOwnProperty('archivedFilter') ? filters.archivedFilter : false,
      alphaSort: filters.hasOwnProperty('alphaSort') ? filters.alphaSort : Sort.none,
      timeSort: filters.hasOwnProperty('timeSort') ? filters.timeSort : Sort.desc,
    })

    this.applyFilters(projectList,
      filters.hasOwnProperty('alphaSort') ? filters.alphaSort : Sort.none,
      filters.hasOwnProperty('timeSort') ? filters.timeSort : Sort.desc,
      filters.hasOwnProperty('projectFilter') ? filters.projectFilter : true,
      filters.hasOwnProperty('templateFilter') ? filters.templateFilter : true,
      filters.hasOwnProperty('activeFilter') ? filters.activeFilter : true,
      filters.hasOwnProperty('archivedFilter') ? filters.archivedFilter : true,
      filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(projectList, alphaSort, timeSort, projectFilter, templateFilter,
    activeFilter, archivedFilter, searchFilter) {
    let filteredList = projectList.sort((p1, p2) => {
      if (alphaSort)
        return alphaSort === Sort.asc ?
          p1.projectName.localeCompare(p2.projectName) : p2.projectName.localeCompare(p1.projectName)
      if (timeSort)
        return timeSort === Sort.asc ?
          p1.dateAccessed - p2.dateAccessed : p2.dateAccessed - p1.dateAccessed
      return 0
    })

    if (!projectFilter)
      filteredList = filteredList.filter(project => project.projectType !== 'project')
    if (!templateFilter)
      filteredList = filteredList.filter(project => project.projectType !== 'template')
    if (!activeFilter)
      filteredList = filteredList.filter(project => project.status !== 'active')
    if (!archivedFilter)
      filteredList = filteredList.filter(project => project.status !== 'archived')
    if (searchFilter)
      filteredList = filteredList.filter(project => project.projectName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    this.setState({filteredProjectList: filteredList})

    let filters = {
      searchFilter: searchFilter,
      projectFilter: projectFilter,
      templateFilter: templateFilter,
      activeFilter: activeFilter,
      archivedFilter: archivedFilter,
      alphaSort: alphaSort,
      timeSort: timeSort
    }
    sessionStorage.setItem(CacheKeys.ProjectsFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onAlphaSortClick = () => {
    let alphaSort = this.state.alphaSort === Sort.asc ? Sort.desc : Sort.asc
    this.setState({
      alphaSort: alphaSort,
      timeSort: Sort.none
    })
    this.applyFilters(this.state.projectList, alphaSort, Sort.none,
      this.state.projectFilter, this.state.templateFilter,
      this.state.activeFilter, this.state.archivedFilter,
      this.state.searchFilter)
  }

  onTimeSortClick = () => {
    let timeSort = this.state.timeSort === Sort.asc ? Sort.desc : Sort.asc
    this.setState({
      timeSort: timeSort,
      alphaSort: Sort.none
    })
    this.applyFilters(this.state.projectList, Sort.none, timeSort,
      this.state.projectFilter, this.state.templateFilter,
      this.state.activeFilter, this.state.archivedFilter,
      this.state.searchFilter)
  }

  onProjectFilterClick = () => {
    let projectFilter = !this.state.projectFilter
    this.setState({projectFilter: projectFilter})
    this.applyFilters(this.state.projectList, this.state.alphaSort, this.state.timeSort,
      projectFilter, this.state.templateFilter,
      this.state.activeFilter, this.state.archivedFilter,
      this.state.searchFilter)
  }

  onTemplateFilterClick = () => {
    let templateFilter = !this.state.templateFilter
    this.setState({templateFilter: templateFilter})
    this.applyFilters(this.state.projectList, this.state.alphaSort, this.state.timeSort,
      this.state.projectFilter, templateFilter,
      this.state.activeFilter, this.state.archivedFilter,
      this.state.searchFilter)
  }

  onActiveFilterClick = () => {
    let activeFilter = !this.state.activeFilter
    this.setState({activeFilter: activeFilter})
    this.applyFilters(this.state.projectList, this.state.alphaSort, this.state.timeSort,
      this.state.projectFilter, this.state.templateFilter,
      activeFilter, this.state.archivedFilter,
      this.state.searchFilter)
  }

  onArchivedFilterClick = () => {
    let archivedFilter = !this.state.archivedFilter
    this.setState({archivedFilter: archivedFilter})
    this.applyFilters(this.state.projectList, this.state.alphaSort, this.state.timeSort,
      this.state.projectFilter, this.state.templateFilter,
      this.state.activeFilter, archivedFilter,
      this.state.searchFilter)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.projectList, this.state.alphaSort, this.state.timeSort,
      this.state.projectFilter, this.state.templateFilter,
      this.state.activeFilter, this.state.archivedFilter,
      searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Projects(context.session.accountId))
    this.setState({
      errorList: null,
      projectList: null,
      filteredProjectList: null
    })
    this.getProjects(context)
  }

  getMessages(context) {
    let arr = [
      'c_projects',
      'c_refresh',
      'c_no_project_msg',
      'c_create_project',
      'c_sort_alpha',
      'c_sort_access_time',
      'c_project',
      'c_template',
      'c_active',
      'c_archived'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_projects', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(ProjectListPageSF)
